import { useState, useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { selectCurrentUser } from '../redux/user/user.selectors';
import { fetchData } from '../api/api';

const useFetchData = (url, options = {}) => {
  const { enabled = true } = options;
  const currentUser = useSelector(selectCurrentUser);
  const authToken = currentUser?.authToken;

  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [isSuccess, setIsSuccess] = useState(false);

  const fetchDataFromUrl = useCallback(() => {
    if (!url || !authToken) {
      setError(new Error('Missing url or authToken'));
      setIsSuccess(false);
      return;
    }

    setIsLoading(true);
    setError(null);
    setIsSuccess(false);
    setData(null);

    fetchData(url, authToken)
      .then((response) => {
        if (
          response.success &&
          response.data !== null &&
          response.data !== undefined
        ) {
          setData(response.data);
          setIsSuccess(true);
        } else {
          setError(new Error('Invalid response data'));
          setIsSuccess(false);
        }
      })
      .catch((err) => {
        setError(err);
        setIsSuccess(false);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [url, authToken]);

  // Fetch on mount or when dependencies change, only if enabled
  useEffect(() => {
    if (enabled) {
      fetchDataFromUrl();
    }

    // Cleanup on unmount
    return () => {
      setData(null);
      setError(null);
      setIsSuccess(false);
      setIsLoading(false);
    };
  }, [fetchDataFromUrl, enabled]);

  return {
    data,
    isLoading,
    error,
    isSuccess,
    refetch: fetchDataFromUrl,
  };
};

export default useFetchData;
